import { useEffect, useRef } from 'react';

const useTimeout = (callback: () => void, delay: number) => {
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay > 0) {
      const id = setTimeout(savedCallback.current, delay);
      return () => clearTimeout(id);
    }
  }, [delay]);
};

export default useTimeout;
